module.exports = __webpack_public_path__ + "img/f2.60bbb933.jpg";